<template>
	<div class="spe-float-icon-wrap" v-if="isShow" 
        :ddt-area="`component_${floorId}`"
        ddt-expose="on">
		<div class="close" :style="{bottom: suspIconBottom + 1.06 + 'rem'}"><i class="iconfont" @click="click">&#xe629;</i></div>
        <div class="content" 
            :style="{backgroundImage: `url(${iconData && iconData.image})`, bottom: suspIconBottom + 'rem'}"
            @click="$sys.dict.href(iconData && iconData.jumpUrl)"
            :data-area="pt()"
            :data-pos="`component_${floorId}_悬浮icon组件.组件_点击跳转`"
            :data-desc="iconData && iconData.image"
            :dd_name="`${pt()}.component_${floorId}_悬浮icon组件.组件_点击跳转.${iconData && iconData.image}`"
            :ddt-click="`${pt()}.component_${floorId}_悬浮icon组件.组件_点击跳转.${iconData && iconData.image}`"
            :ddt-pit="`组件_点击跳转`"
            :ddt-src="iconData && iconData.image"
            ddt-expose="on"
        ></div>
	</div>
</template>

<script>
export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
        },
        posInfo: {
            type:Object,
            default: () => {
                return {}
            }
        },
        isMina: {
            type: Boolean,
            default: false
        },
        isIos: {
            type: Boolean,
            default: false
        },
        isAndroid: {
            type: Boolean,
            default: false
        }
	},
	data() {
		return {
            isShow: true,
            floorId: '',
            iconData: {}
        };
	},
    inject: ['pt'],
    computed: {
        suspIconBottom () {
            let { bottomTab, countDown, toTop } = this.posInfo
            const data = this.isIos && this.isMina ? 0.68 : 0
            if (bottomTab && countDown && toTop) {
                return 3.00 + data
            } else if (bottomTab && countDown && !toTop) {
                return 2.00 + data
            } else if (!bottomTab && countDown && toTop) {
                return 2.00 + data
            } else if (!bottomTab && countDown && !toTop) {
                return 1.00 + data
            } else if (!bottomTab && !countDown && toTop) {
                return 2.00 + data
            } else if (!bottomTab && !countDown && !toTop) {
                return 1.00 + data
            } else if (bottomTab && !countDown && !toTop) {
                return 1.20 + data
            } else if (bottomTab && !countDown && toTop) {
                return 2.20 + data
            }
        }
    },
	watch: {
        json: {
            handler(newVal, oldVal) {
                let { data, floorId } = newVal
                this.floorId = floorId
                this.iconData = data
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        click() {
            this.isShow = false
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-float-icon-wrap {
    .close {
        position: fixed;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        background: rgba(0,0,0,0.40);
        line-height: 18px;
        right: 6px;
        z-index: 99;
        text-align: center;
        i {
            font-family: iconfont;
            font-size: 12px;
            color: #FFFFFF;
            font-weight: 100;
        }
    }
    .content {
       position: fixed;
       width: 120px;
       height: 120px;
       right: 10px;
       background-size: 100% 100%;
       z-index: 90;
    }
}
</style>
